module.exports = __webpack_public_path__ + "static/img/t2-2-2.eef3692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t2-2-2.png
// module id = F8cy
// module chunks = 1